import { useCloudComputingPower } from 'store'
import { lodashDeepClone, merge } from 'utils'
import ico from '../../assets/image/97/favicon.png'
import bannerRight from '../../assets/image/97/home/banner-right.png'
import downloadBg from '../../assets/image/97/home/support-platform/download-bg.png'
import { default as logo, default as simpleLogo } from '../../assets/image/97/logo.png'
import { BaseConfig, type BaseConfigSource } from '../common-config'

const primary = '#f7b239'
const lightPrimary = '#f7b239'
const secondaryPrimary = '#f7b239'
const tertiaryPrimary = '#8B1A1A'

export const E97CreditLightConfig: PlatformConfig = merge<BaseConfigSource, PlatformConfig>(lodashDeepClone(BaseConfig), {
  themeType: 'light',
  logo: logo,
  simpleLogo,
  footerLogo: logo,
  logoWidth: 32,
  footerLogoWidth: 56,
  platformName: import.meta.env.VITE_PLATFORM_NAME,
  contentWidth: `1200px`,
  loginShowDownload: true,
  colors: {
    lightPrimary: lightPrimary,
    hoverPrimary: '#151519',
    zero: '#C2C7D0',
    // 根据最新的UI提供的色值库的颜色
    primary,
    secondaryPrimary,
    tertiaryPrimary,
    link: '#4B5BE7',
    text: {
      base: '#151519',
      reverse: '#151519',
      primaryAlt: '#151519',
      secondary: '#75777A',
      tertiary: '#A0A3A7',
      quaternary: '#75777A',
      hover: '#151519',
    },
    bg: {
      base: '#FFFFFF',
      reverse: '#151519',
      secondary: '#FFFFFF',
      hover: '#EAECEF4C',
      tertiary: '#f7f7f9',
      icon: {
        primary: '#151519',
        secondary: '#75777A',
        trigger: '#E3E3E3',
        quaternary: '#8E9196',
      },
      button: {
        base: primary,
        primary: primary,
        aux: '#F6F7F9',
        disabled: '#C2C7D0',
        primaryTextColor: '#151519',
      },
      tag: {
        base: '#F3F4F6',
      },
      form: {
        base: '#F7F7F9',
        input: '#F7F7F9',
        modal: '#F1F3F6',
        card: '#ffffff',
      },
      mainPage: {
        base: '#FFFFFF',
        card: '#F5F5F7',
        actionBar: '#f3f4f6',
      },
      modal: {
        base: '#FFFFFF',
        card: '#ffffff',
        shadow: 'rgba(224, 227, 237, 0.9)',
      },
    },
    tip: '#F6F7F9',
    cardBorder: '#EAECEF',
    divider: '#EAECEF',
    borderSelected: '#74777B',
    sliderMenu: '#F4F5F6',
  },
  ico,
  header: {
    color: '#151519',
    // boxShadow: '0 1px 10px rgba(0, 0, 0, 0.11)',
    background: '#fff',
    aColor: '#151519',
    regBtnBgColor: '#f7b239', // 注册按钮背景
    regTextColor: '#10151F', // 注册按钮文字颜色
    downloadTextColor: '#151519',
    activeColor: '#151519',
  },
  home: {
    banner: {
      bannerRight: bannerRight,
    },
    supportPlatform: {
      downloadBg: downloadBg,
    },
  },
  loadExternalConfig() {
    return useCloudComputingPower().loadExternalConfig()
  },
  cloud: {
    colors: {
      bg: {
        card: {
          primary: '#F3F4F6',
          fontColor: '#151519',
        },
      },
    },
  },
} as BaseConfigSource as PlatformConfig)
